module.exports = __webpack_public_path__ + "static/media/silverjaw.7a29376f.png";